import React from 'react';

import * as S from './GIToggle.styles';

const SalesHandlingBtn = ({isEnabled, id, handleToggle, enabledColor, disabledColor}) => {
  const defaultEnabledColor = enabledColor || 'rgb(0, 140, 255)';
  const defaultDisabledColor = disabledColor || 'rgb(234, 245, 255)';
  return (
    <S.SwtchBtn>
      <S.InputBtn
        aria-label="toggle-button"
        checked={isEnabled}
        onChange={handleToggle}
        id={id}
        type="checkbox"
      ></S.InputBtn>
      <S.Label
        htmlFor={id}
        isEnabled={isEnabled}
        defaultEnabledColor={defaultEnabledColor}
        defaultDisabledColor={defaultDisabledColor}
      >
        <S.Toggle></S.Toggle>
      </S.Label>
    </S.SwtchBtn>
  );
};

export default SalesHandlingBtn;
